import { AllEndCustomersResponseModel, BrandsResponseModel, EndCustomerResponseModel, EndCustomersDropDownDataResponseModel, GetAllBrandsResponseModel } from '@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req, UploadedFile, UseInterceptors } from '@nestjs/common';
import { FileInterceptor } from '@nestjs/platform-express';
import { ApiConsumes, ApiTags } from '@nestjs/swagger';
import { extname } from 'path';

import { diskStorage } from 'multer';
import { Any } from 'typeorm';
import { BrandRequest } from './dto/brand.request';
import { EndCustomersDTO } from './dto/end-customer.dto';
import { EndCustomerRequest } from './dto/end-customer.request';
import { EndCustomersService } from './end-customer.service';
import { FileUploadResponse } from '@gtpl/shared-models/logistics';
import { EndCustomerImgUploadDto } from './dto/end-customer-image-upload';
import { UserRequestDto } from '../countries/dto/user-request-dto';
// import { EndCustomerRequest } from './dto/customer.request';
// import { EndCustomersDTO } from './dto/endCustomers.dto';
@ApiTags('EndCustomers')
@Controller('endCustomers')
export class EndCustomersController {
    constructor(
        private endCustomersService: EndCustomersService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }
    /**
     * creates or updates a value of EndEndCustomers
     * @param EndCustomersDto EndEndCustomers DTO
     * @returns EndCustomersResponse
     */
    @Post('/createEndCustomers')
    async createEndCustomers(@Body() endCustomersDTO: EndCustomersDTO, isUpdate: boolean = false): Promise<EndCustomerResponseModel> {
        try {
            return await this.endCustomersService.createEndCustomer(endCustomersDTO, false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EndCustomerResponseModel, error)
        }
    }
    /**
     *  creates or updates a value of EndEndCustomers
     * @param EndCustomersDTO 
     * @param request 
     */
    @Post('/updateEndCustomer')
    async updateEndCustomer(@Body() EndCustomersDTO: EndCustomersDTO): Promise<EndCustomerResponseModel> {
        try {
            return await this.endCustomersService.createEndCustomer(EndCustomersDTO, true);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EndCustomerResponseModel, error)
        }
    }

    /**
     * get All EndEndCustomers Details
     * @param request 
     */
    @Post('/getAllEndCustomers')
    async getAllEndCustomers(@Body() req?:UserRequestDto): Promise<AllEndCustomersResponseModel> {
        try {
            return await this.endCustomersService.getAllEndCustomers(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllEndCustomersResponseModel, error)
        }
    }

    @Post('/getCustomerDataById')
    async getEndCustomerDataById(@Body() endCustomerRequest:EndCustomerRequest,@Req() request: Request): Promise<EndCustomerResponseModel> {
        try {
        return await this.endCustomersService.getEndCustomerDataById(endCustomerRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EndCustomerResponseModel, error)
        }
    }

    /**
     * Activate or Deactivate EndCustomer
     * @param endCustomerReq 
     */
    @Post('/activateorDeactivateendCustomers')
    async activateorDeactivateendCustomers(@Body() endCustomerReq: EndCustomerRequest): Promise<EndCustomerResponseModel> {
        try {
            return await this.endCustomersService.activateOrDeactivateEndCustomer(endCustomerReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(EndCustomerResponseModel, err);
        }
    }

    /**
     * get All EndEndCustomers Details
     * @param request 
     */
    @Post('/getActiveEndCustomers')
    async getActiveEndCustomersData(): Promise<AllEndCustomersResponseModel> {
        try {
            return await this.endCustomersService.getActiveEndCustomersData();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllEndCustomersResponseModel, error)
        }
    }
    /**
     * 
     * @param brandId 
     * @returns 
     */
    @Post('/getBrandsById')
    async getBrandsById(@Body() brandsRequest:BrandRequest): Promise<BrandsResponseModel> {
        console.log(brandsRequest.brandId);
        try {
            return await this.endCustomersService.getBrandsById(brandsRequest.brandId);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(BrandsResponseModel,error)
        }
    }

    @Post('/getAllBrands')
    async getAllBrands(): Promise<GetAllBrandsResponseModel> {
        try {
            return await this.endCustomersService.getAllBrands();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetAllBrandsResponseModel,error)
        }
    }
    @Post('/getAllActiveBrands')
    async getAllActiveBrands(): Promise<GetAllBrandsResponseModel> {
        try {
            return await this.endCustomersService.getAllActiveBrands();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetAllBrandsResponseModel,error)
        }
    }


    @Post('/logoUpload')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FileInterceptor('file', {
      limits: { files: 1 },
      storage: diskStorage({
        destination: './upload-files/logo-files',
        filename: (req, file, callback) => {
          const name = file.originalname.split('.')[0];
          const fileExtName = extname(file.originalname);
          const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
          callback(null, `${name}-${randomName}${fileExtName}`);
        },
      }),
      fileFilter: (req, file, callback) => {
        if (!file.originalname.match(/\.(png|jpeg|jpg|JPG)$/)) {
          return callback(new Error('Only png,jpeg files are allowed!'), false);
        }
        callback(null, true);
      },
    }))
    async logoUpload(@UploadedFile() file, @Body() uploadData: EndCustomerImgUploadDto): Promise<FileUploadResponse> {
      try {
        // if(file){
        //  endCustomersDTO.filePath = file.path;
        //  endCustomersDTO.fileName = file.filename;
        // }
        return await this.endCustomersService.updatePath(file.path,file.filename, uploadData.endCustomerId);
      } catch (error) {
        return this.applicationExceptionhandler.returnException(FileUploadResponse, error);
      }
    }

    @Post('/getAllEndCustomersDropData')
    async getAllEndCustomersDropData(): Promise<CommonResponse> {
        try {
            return await this.endCustomersService.getAllEndCustomersDropData();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getBrandsForEndCustomerId')
    async getBrandsForEndCustomerId(@Body() endCustomerRequest:EndCustomerRequest): Promise<EndCustomerResponseModel> {
        try {
        return await this.endCustomersService.getBrandsForEndCustomerId(endCustomerRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EndCustomerResponseModel, error)
        }
    }


    
}


